<form [formGroup]="poiForm" class="example-form w-100 mb-2" style="height:72vh; overflow-y: auto;">
    <div class="shared-access-hint" *ngIf="contextAccess !== 'owner'">
        <mat-icon>info_outline</mat-icon>
        <span *ngIf="isViewOnly">{{'POI_view_only' | translate}}</span>
        <span *ngIf="!isViewOnly">{{'POI_shared_info' | translate}}</span>
    </div>

    <div class="my-map-container" *ngIf="!!data.data" [class.geo-locked]="isGeoLocked">
        <app-map-info-display [object]="data" (onMapClick)="mapClicked()"></app-map-info-display>
    </div>

    <div class="section-header">{{'FORM.poiForm.h_general' | translate}}</div>

    <mat-form-field class="w-100">
        <mat-label>{{'FORM.poiForm.type' | translate}}</mat-label>
        <mat-select formControlName="geoObjectType" required>
            <mat-option *ngFor="let type of dropdownSettingGeoObjectType" [value]="type">
                <!-- <img [src]="'assets/icons/'+data.iconName+'.svg'" alt=""> -->
                {{type.title}}
            </mat-option>
        </mat-select>
        <mat-error *ngIf="poiForm.controls.geoObjectType.errors?.required"> {{ 'FORM_VALIDATION.REQUIRED' | translate }}</mat-error>
    </mat-form-field>

    <mat-form-field class="w-100">
        <mat-label>{{'EXPORT.poiForm.category' | translate}}</mat-label>
        <mat-select formControlName="category" multiple>
            <mat-option *ngFor="let category of dropdownSettingGeoObjectCategory" [value]="category.identifier">{{category.title}}</mat-option>
        </mat-select>
    </mat-form-field>

    <div>
        <mat-form-field class="w-50 pr-1">
            <mat-label>{{'FORM.poiForm.shortName' | translate}}</mat-label>
            <input formControlName="shortName" matInput type="text" required>
            <mat-error *ngIf="poiForm.controls.geoObjectType.errors?.required">{{ 'FORM_VALIDATION.REQUIRED' | translate }}</mat-error>
        </mat-form-field>
    
        <mat-form-field class="w-50 pl-1">
            <mat-label>{{'FORM.poiForm.shortID' | translate}}</mat-label>
            <input formControlName="shortID" matInput type="text">
        </mat-form-field>
    </div>

    <mat-form-field class="w-100">
        <mat-label>{{'FORM.poiForm.huntingDistrict' | translate}}</mat-label>
        <mat-select formControlName="huntingDistrict">
            <mat-option *ngFor="let district of dropdownHuntingDistrict" [value]="district">{{district.name}}</mat-option>
        </mat-select>
    </mat-form-field>

    <!-- Planning status only applies to types that are inspected on an interval. -->
    <mat-form-field class="w-100" *ngIf="showPlanningStatus">
        <mat-label>{{'FORM.poiForm.planningStatus' | translate}}</mat-label>
        <mat-select formControlName="planningStatus">
            <mat-option *ngFor="let plans of planningStatus" [value]="plans">{{ 'FORM.poiForm.planningStatusOptions.'+ plans | translate}}</mat-option>
        </mat-select>
    </mat-form-field>

    <div>
        <mat-form-field class="w-50 pr-1">
            <mat-label>{{'FORM.poiForm.lastTestDate' | translate}}</mat-label>
            <input matInput [matDatepicker]="testDatePicker" formControlName="lastTestDate">
            <mat-datepicker-toggle matSuffix [for]="testDatePicker"></mat-datepicker-toggle>
            <mat-datepicker #testDatePicker></mat-datepicker>
        </mat-form-field>
    
        <mat-form-field class="w-50 pl-1">
            <mat-label>{{'FORM.poiForm.nextTestDate' | translate}}</mat-label>
            <input matInput [value]="nextTestDate | date:'dd.MM.yyyy'" readonly>
        </mat-form-field>
    </div>

    <mat-form-field >
        <mat-label>{{'FORM.poiForm.testIntervalDays' | translate}}</mat-label>
        <input matInput type="number" formControlName="testIntervalDays" placeholder="z.B. 365">
    </mat-form-field>

    <div class="p-1 m-1">
        <div class="section-header">{{'FORM.poiForm.h_locationData' | translate}}</div>
        <mat-form-field class="w-100">
            <mat-label>{{'FORM.poiForm.locationHeading' | translate}}</mat-label>
            <input formControlName="locationHeading" matInput type="number" min="0" max="360">
            <mat-hint>{{'FORM.poiForm.heading_hint' | translate}}</mat-hint>
            <mat-error *ngIf="poiForm.controls.locationHeading.errors?.min || poiForm.controls.locationHeading.errors?.max">{{'FORM.poiForm.heading_error' | translate}}</mat-error>
        </mat-form-field>
    </div>

    <div class="notification-channel w-100" *ngIf="showNotificationChannel">
        <label class="notification-channel-label">{{'FORM.poiForm.notificationChannel' | translate}}</label>

        <div class="notification-channel-list" *ngIf="notificationChannel.length">
            <div class="notification-channel-row" *ngFor="let entry of notificationChannel; let i = index">
                <mat-icon class="nc-icon">{{ entry.displayName ? 'person' : 'mail' }}</mat-icon>
                <span class="nc-name">{{ entry.displayName || entry.email }}</span>
                <span class="nc-email" *ngIf="entry.displayName">{{ entry.email }}</span>
                <button
                    mat-icon-button
                    type="button"
                    (click)="removeNotificationChannel(i)"
                    matTooltip="{{'remove' | translate}}">
                    <mat-icon>close</mat-icon>
                </button>
            </div>
        </div>

        <mat-form-field class="w-100 notification-channel-picker">
            <mat-label>{{'FORM.poiForm.pick_notification_users' | translate}}</mat-label>
            <mat-select multiple [formControl]="channelUserPickerCtrl" (closed)="onChannelUserPickerClosed()">
                <mat-option *ngFor="let u of availableChannelUsers" [value]="u.identifier">
                    {{ userNameLookup.displayNameOf(u) }}
                    <span class="nc-option-email" *ngIf="u.email">({{ u.email }})</span>
                </mat-option>
            </mat-select>
        </mat-form-field>

        <div class="notification-channel-divider mb-3">{{'or' | translate}}</div>

        <div class="notification-channel-add">
            <mat-form-field appearance="outline" class="notification-channel-input">
                <mat-label>{{'FORM.poiForm.add_notification_channel' | translate}}</mat-label>
                <input
                    matInput
                    type="text"
                    [formControl]="channelInputCtrl"
                    placeholder="name@example.com"
                    (keydown.enter)="onChannelInputEnter($event)">
                <button
                    mat-icon-button
                    matSuffix
                    type="button"
                    [disabled]="!canAddTypedChannelEmail"
                    (click)="addTypedChannelEmail()"
                    matTooltip="{{'add' | translate}}">
                    <mat-icon>add</mat-icon>
                </button>
            </mat-form-field>
        </div>
    </div>

    <app-context-rights-picker formControlName="contextIdRights"></app-context-rights-picker>

</form>

<div class="sticky-bottom">
    <button [disabled]="!canSave" class="first-btn w-100 my-1" mat-raised-button type="submit" (click)="onSubmit()">
        {{ 'FORM.BTN_SAVE' | translate }}
    </button>

    <button [disabled]="!canDelete" class="second-btn w-100 my-1" mat-button type="submit" (click)="onDelete()">
        {{ 'FORM.BTN_DELETE' | translate }}
    </button>
</div>